let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];

class ContactService {

    constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
        this.$q = $q;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
        this.AuthTokenFactory = AuthTokenFactory;
        this.SharedService = SharedService;
        this.SessionService = SessionService;
    }

    getContactLocations(id = '') {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.
                    getContactLocations + '?operatingCenterId='+id,
                cache: false
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    sendMailContact(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.mailContact,
                data: this.$httpParamSerializerJQLike(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then((response) => {
                resolve(response.data);
            }).catch((reason) => {
                reject(reason);
            });
        });
    }


}

ContactService.$inject = inject;

export default ContactService;



/** WEBPACK FOOTER **
 ** ./www/components/contact/contact.service.js
 **/